import { Anchor, AnchorProps, Text } from "@govlaunch/web";
import React from "react";
import { FormattedMessage } from "react-intl";
import useIsMobile from "~/lib/hooks/useIsMobile";

const TranslationLinkButton = React.forwardRef<HTMLAnchorElement, AnchorProps>(({ onClick, href, paddingY }, ref) => {
  const isMobile = useIsMobile();

  return (
    <Anchor href={href} onClick={onClick} ref={ref}>
      <Text
        color={isMobile ? "gray.900" : "blue.600"}
        fontSize={isMobile ? "12px" : "14px"}
        border={isMobile ? "1px solid #ADB6C3" : ""}
        borderRadius="4px"
        py={paddingY ? paddingY : "4px"}
        px="10px"
      >
        <FormattedMessage defaultMessage="see translation" id="jJqiqa" />
      </Text>
    </Anchor>
  );
});

export default TranslationLinkButton;
